var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralErrorPlaceholder = function SvgGeneralErrorPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 680 329"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2EB",
    d: "M594 133h21v76h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2EB",
    d: "M628 194.563 578.058 131l-100.246.98L417 195.349l1.229.844h-.439V328h210.076V196.193z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEC4CF",
    d: "M578.31 131 516 209.309V328h112V194.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M561 262h23v22h-23zm0-37h23v21h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M561 262h23v22h-23zm0-37h23v21h-23zm-102 31h23v22h-23zm0-37h23v21h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2EB",
    d: "M432 133h21v76h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2EB",
    d: "M466 194.563 416.058 131l-100.246.98L255 195.349l1.229.844h-.439V328h210.076V196.193z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEC4CF",
    d: "M416.31 131 354 209.309V328h112V194.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M399 262h23v22h-23zm0-37h23v21h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M399 262h23v22h-23zm0-37h23v21h-23zm-102 31h23v22h-23zm0-37h23v21h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2EB",
    d: "M259 67h27v102h-27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2EB",
    d: "M304 149.18 237.254 64l-133.98 1.313L22 150.234l1.642 1.132h-.587V328H303.82V151.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEC4CF",
    d: "M237.451 64 154 168.942V328h150V148.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M214 240h31v29h-31zm0-50h31v29h-31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M214 240h31v29h-31zm0-50h31v29h-31zM78 233h31v29H78zm0-51h31v29H78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M0 328h657v1H0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 257.5,
    fill: "#3F3D56",
    rx: 20,
    ry: 43.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M105.483 328c-7.797-50.84-.079-101.495 0-102l1.517.28c-.079.502-7.753 50.891 0 101.446l-1.517.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "m102.972 258.184 17.923-10.272.74 1.48-17.923 10.272zM84.056 254.538l.74-1.48 17.92 10.277-.739 1.48z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56,
    cy: 190.5,
    fill: "#37A3BC",
    rx: 39,
    ry: 84.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M59.541 329c-14.643-99.686-.148-199.008 0-200l1.459.28c-.148.99-14.601 100.045 0 199.445l-1.459.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m55.25 192.978 35.057-20.091.738 1.48-35.056 20.091zM18.253 184.432l.738-1.48 35.052 20.1-.74 1.48z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148,
    cy: 139,
    fill: "#37A3BC",
    rx: 53,
    ry: 116
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M153.458 329c-21.173-136.57-.214-272.642 0-274l1.542.28c-.214 1.357-21.128 137.16 0 273.444l-1.542.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m146.992 143.19 47.971-27.493.739 1.48-47.971 27.492zM96.363 130.949l.74-1.48 47.964 27.506-.739 1.48z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 593,
    cy: 257.5,
    fill: "#3F3D56",
    rx: 20,
    ry: 43.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M591.517 328c7.797-50.84.079-101.495 0-102l-1.517.28c.079.502 7.753 50.891 0 101.446l1.517.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "m575.1 249.392.738-1.48 17.923 10.27-.738 1.481zM594.018 263.336l17.92-10.279.74 1.48-17.92 10.278z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 641,
    cy: 190.5,
    fill: "#37A3BC",
    rx: 39,
    ry: 84.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M636.459 329c14.643-99.686.148-199.008 0-200l-1.459.28c.148.99 14.601 100.045 0 199.445l1.459.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m605.69 174.368.738-1.481 35.057 20.09-.739 1.481zM642.692 203.052l35.05-20.1.74 1.48-35.052 20.1z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 549,
    cy: 139,
    fill: "#37A3BC",
    rx: 53,
    ry: 116
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M542.542 329c21.173-136.57.214-272.642 0-274l-1.542.28c.214 1.357 21.128 137.16 0 273.444l1.542.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m501.033 117.177.738-1.48 47.972 27.493-.739 1.48zM551.667 156.976l47.965-27.507.74 1.48-47.965 27.506zM401.585 74.446l6.415-5.37c-4.983-.576-7.03 2.269-7.869 4.52-3.893-1.692-8.131.526-8.131.526L404.835 79a10.148 10.148 0 0 0-3.25-4.554zm-153-48 6.415-5.37c-4.983-.576-7.03 2.269-7.869 4.52-3.893-1.692-8.131.526-8.131.526L251.835 31a10.148 10.148 0 0 0-3.25-4.554zm250-21L505 .076c-4.983-.576-7.03 2.269-7.869 4.52-3.893-1.692-8.131.526-8.131.526L501.835 10a10.148 10.148 0 0 0-3.25-4.554zm12.004 313.021a8.825 8.825 0 0 0-4.702 1.371c-2.966-2.915-7.233-3.656-10.886-1.89-3.654 1.766-6.006 5.706-6.001 10.052h31c-.35-5.37-4.459-9.53-9.411-9.533zm-318 0a8.825 8.825 0 0 0-4.702 1.371c-2.966-2.915-7.233-3.656-10.886-1.89-3.654 1.766-6.006 5.706-6.001 10.052h31c-.35-5.37-4.459-9.53-9.411-9.533zm163 0a8.825 8.825 0 0 0-4.702 1.371c-2.966-2.915-7.233-3.656-10.886-1.89-3.654 1.766-6.006 5.706-6.001 10.052h31c-.35-5.37-4.459-9.53-9.411-9.533zM321 295h-90v3.143h14.036V328h2.903v-29.857h54.67V328h2.903v-29.857H321zm-90-9h90v3h-90zm0-8h90v3h-90zm0-8h90v3h-90zm231 25h-90v3.143h14.036V328h2.903v-29.857h54.67V328h2.903v-29.857H462zm-90-9h90v3h-90zm0-8h90v3h-90zm0-8h90v3h-90z"
  }))));
};
export default SvgGeneralErrorPlaceholder;